import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddWebsite( { accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer    pageName={'Set up a new website'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

